export const CHAT_LIST = (professionalId?: string) =>
  `${import.meta.env.VITE_API_BASE_URL}/v1/chat-participants-list/professional/${professionalId}`

const CHAT_BASE = `${import.meta.env.VITE_API_BASE_URL}/v1/chat`

export const CHAT_CREATE_PARTICIPANT = (participantId?: string) =>
  `${CHAT_BASE}/${participantId}`

export const CHAT_PARTICIPANT = (chatId?: string) =>
  `${CHAT_BASE}/${chatId}/participant`

export const CHAT_MESSAGE = (chatId?: string) =>
  `${CHAT_BASE}/${chatId}/message`

export const CHAT_LAST_MESSAGE = (chatId?: string) =>
  `${CHAT_MESSAGE(chatId)}/last`
